import React, { useRef } from 'react';

import { FormControl, Input, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { primitive } from 'styles/constants/primitives';

import { useCheckoutValidation } from '../../../hooks/use-checkout-validation';
import { IVehicleDescriptionProps } from '../types';

const DescriptionInput = Input.withConfig({
  width: 'full',
  borderWidth: 1,
  borderColor: primitive.$blackOpacity30,
  borderStyle: 'solid',
  borderRadius: 4,
  style: {
    shadowColor: Styles.shadowColor,
    shadowOffset: {
      width: 0,
      height: 0.5,
    },
    shadowRadius: 1.5,
    shadowOpacity: 1,
  },
  color: primitive.bk.$bbqBrown,
  fontFamily: 'body',
  fontSize: 'md',
  placeholderTextColor: primitive.$blackOpacity50,
  paddingTop: '$3',
  paddingBottom: '$3',
  paddingLeft: '$4',
  paddingRight: '$4',
});

const DescriptionContainer = FormControl.withConfig({
  borderWidth: 0,
  borderColor: 'black',
  borderStyle: 'solid',
  marginTop: '$4',
  marginBottom: 0,
});

export const VehicleDescriptionMobilePickup: React.FC<React.PropsWithChildren<
  IVehicleDescriptionProps
>> = ({ onChange, value }) => {
  const { formatMessage } = useIntl();
  const inputRef = useRef<HTMLInputElement>(null);
  const { validate } = useCheckoutValidation();
  const checkoutErrors = validate();
  const errors = checkoutErrors.filter(error => error.placement === 'vehicleDescription');
  const isValid = errors.length === 0;

  const handleChange = (description: string) => {
    const value = description?.trimStart();
    onChange({ value, hasError: !isValid });
  };

  return (
    <DescriptionContainer>
      <View style={styles.titleContainer}>
        <Text style={styles.titleText}>{formatMessage({ id: 'mobilePickupVehicleTitle' })}</Text>
        <Text>({formatMessage({ id: 'required' })})</Text>
        <Text style={styles.asteriskText}>*</Text>
      </View>
      <DescriptionInput
        testID="vehicle-description"
        placeholder={formatMessage({ id: 'mobilePickupVehicleDescriptionPlaceholder' })}
        onChangeText={handleChange}
        value={value}
        ref={inputRef}
      />
      {!isValid ? (
        <Text style={styles.errorMessage}>{errors[0].message}</Text>
      ) : (
        <Text style={styles.descriptionHelp}>
          {formatMessage({ id: 'mobilePickupVehicleDescription' })}
        </Text>
      )}
    </DescriptionContainer>
  );
};

const styles = StyleSheet.create({
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    marginBottom: 8,
  },
  titleText: {
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: primitive.fontFamily.$headers,
    marginRight: 8,
  },
  asteriskText: {
    color: primitive.$error,
  },
  errorMessage: {
    color: primitive.$error,
    fontSize: 12,
  },
  descriptionHelp: {
    fontSize: 12,
  },
});
